module.exports = __webpack_public_path__ + "static/media/ico_simulation_lip_lower.10435571.png";